<template>
  <v-row justify="center">
    <v-col cols="12">
      <!-- Botón para registrar ingreso -->
      <PrimaryButton @click="dialog = true">
        Agregar sucursal
      </PrimaryButton>
    </v-col>
    <!-- Contenedor de el botón -->
    <v-dialog v-model="dialog" persistent max-width="600px">
      <!-- Modal -->
      <v-card v-if="!isLoading">
        <!-- Título -->
        <v-card-title>
          <p class="headline font-weight-bold mb-0">Agrega una sucursal</p>
        </v-card-title>
        <!-- Formulario -->
        <v-card-text class="mb-0 pb-0">
          <v-container fluid class="pa-0">
            <v-row no-gutters>
              <!-- Nombre -->
              <v-flex xs12>
                <TextField
                  class="mb-3"
                  placeholder="Nombre de la sucursal"
                  v-model="name"
                />
              </v-flex>
              <!-- Obtener dirección -->
              <v-flex xs12>
                <AddressField
                  ref="addressField"
                  placeholder="Dirección de la sucursal"
                  v-on:address="onAddressChange"
                />
              </v-flex>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="reset">Cancelar</v-btn>
          <v-btn color="primary" text @click="addBranch">Agregar</v-btn>
        </v-card-actions>
      </v-card>
      <!-- Tarjeta si está cargando -->
      <v-card v-else align="center" justify="center">
        <v-progress-circular class="mt-12 mb-4" indeterminate color="primary" />
        <v-card-text class="text-center pb-12">
          Estamos registrando la sucursal
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
// importar servicios
import BranchesServices from "@/services/BranchesServices";

// importar componentes
import PrimaryButton from "@/components/PrimaryButton";
import TextField from "@/components/TextField";
import AddressField from "@/components/AddressField";

// Importar dependencias
import { mapGetters } from "vuex";

export default {
  name: "create-sucursal",
  components: {
    PrimaryButton,
    TextField,
    AddressField
  },
  data() {
    return {
      dialog: false,
      isLoading: false,
      name: "",
      address: ""
    };
  },
  methods: {
    // Petición para obtener la dirección con todos los datos
    onAddressChange: function(addressData) {
      this.address = addressData;
    },
    addBranch: async function() {
      // Verificar si los campos están completos
      if (!this.areFieldsComplete) {
        // Emitir evento con el error
        this.$emit("branch-error", "Rellena todos los campos");
        return;
      }

      // Creamos el objeto de la sucursal
      const branch = {
        name: this.name,
        location: {
          latitude: this.address.latitude,
          longitude: this.address.longitude,
          address: `${this.address.route ? this.address.route : ""} ${
            this.address.street_number ? this.address.street_number : ""
          } ${this.address.locality ? this.address.locality : ""}`
        }
      };

      try {
        // Mostrar spinner
        this.isLoading = true;

        // Crear sucursal
        await BranchesServices.createBranch(branch);

        // Enviar evento a mixpanel
        this.$mixpanel.track("new-branch", {
          distinct_id: this.getProfile.business_id
        });

        // Vaciamor los campos
        this.reset();

        // Ocultar spinner
        this.isLoading = false;

        // Refrescamos la página
        this.$emit("new-branch");
      } catch (err) {
        // Ocultar spinner
        this.isLoading = false;

        // Emitir evento con el error
        this.$emit("branch-error", err.message);
      }
    },
    reset: function() {
      // Vaciamos campos
      this.name = "";
      this.address = "";
      // this.$refs.addressField.$refs.address.clear();

      // Cerramos el dialogo
      this.dialog = false;
    }
  },
  computed: {
    ...mapGetters(["getProfile"]),
    areFieldsComplete: function() {
      return !!this.name && !!this.address;
    }
  }
};
</script>

<style scoped></style>
